import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function Urgency() {
  return <section className="w-full py-8 md:py-12 px-4 bg-red-50/50 border-t border-b border-red-100" data-id="element-268">
      <div className="max-w-3xl mx-auto" data-id="element-269">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-red-100" data-id="element-270">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-271">
            <AlertTriangle className="w-6 h-6 md:w-8 md:h-8 text-red-500" data-id="element-272" />
            <h3 className="text-xl md:text-3xl font-bold text-gray-900" data-id="element-273">
              ⚠️ Importante
            </h3>
          </div>

          <p className="text-base md:text-lg text-gray-800 mb-4 font-medium" data-id="element-274">
            Cada día que pasa:
          </p>

          <div className="space-y-2 mb-6 bg-red-50 p-4 rounded-xl inline-block text-left" data-id="element-275">
            <p className="text-base md:text-lg font-bold text-red-700 flex items-center gap-2" data-id="element-276">
              <span data-id="element-277">👉</span> seguís gastando
            </p>
            <p className="text-base md:text-lg font-bold text-red-700 flex items-center gap-2" data-id="element-278">
              <span data-id="element-279">👉</span> seguís dependiendo del supermercado
            </p>
          </div>

          <p className="text-base md:text-lg text-gray-800 font-bold" data-id="element-280">
            Podés seguir igual… o empezar hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}